import { PrismaClient } from "../../../../generated/prisma";
const prisma = new PrismaClient();

/**
 * PATCH Route Handler
 * -------------------
 * This function handles HTTP PATCH requests for updating the number of likes
 * on a specific media item in the database.
 * 
 * It expects:
 * - A route parameter `id` (the media ID)
 * - A JSON body containing `{ liked: true/false }`
 */
export async function PATCH(request, { params }) {
  // Extract the `id` parameter from the route (e.g., /api/media/12)
  const { id } = await params;

  // Convert the ID from string to integer
  const mediaId = parseInt(id, 10);

  // Parse the JSON body sent in the request (expects `{ liked: true/false }`)
  const { liked } = await request.json();

  // Retrieve the existing media entry from the database
  const media = await prisma.media.findUnique({ where: { id: mediaId } });

  // If no media is found with that ID, return a 404 Not Found response
  if (!media) {
    return new Response(
      JSON.stringify({ error: "Media not found" }),
      { status: 404 }
    );
  }

  /**
   * Compute the new number of likes:
   * - If `liked` is true → increment by 1
   * - If `liked` is false → decrement by 1, but never below 0
   */
  const newNumberOfLikes = liked
    ? media.likes + 1
    : Math.max(0, media.likes - 1);

  // Update the media entry in the database with the new number of likes
  const updatedMedia = await prisma.media.update({
    where: { id: mediaId },
    data: { likes: newNumberOfLikes },
  });

  // Return a successful response with the updated like count
  return new Response(
    JSON.stringify({ likes: updatedMedia.likes }),
    { status: 200 }
  );
}
